/**
 * 验证手机格式
 * @param {*} tel
 */
export const isTel = (tel: string) =>
  /(^[1][2,3,4,5,6,7,8,9][0-9]{9}$)|(^[2,8,6][0-9]{7}$)|(^[2,3,5,6,9][0-9]{7}$)/.test(tel);

/**
 * 验证账号格式
 * @param {*} account
 */
export const isAccount = (account: string) => /(^[a-zA-Z][A-Za-z0-9]{5,19}$)/.test(account);

/**
 * 验证密码格式
 * @param {*} password
 */
export const isPassword = (password: string) => /(^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$)/.test(password);

/**
 * 字符串是否为纯数字
 * @param {*} checkNumber
 */
export const isCheckNumber = (checkNumber: string) => /(^[0-9]+.?[0-9]$)/.test(checkNumber);

/**
 * 计算目标字符串是否超过特定字节长度
 * @param s:字符串
 * @param n:字节长度（1字符（中文）= 2字节，1字母/数字=1字节）
 * @param return 超过返回要展示的悬浮文本，否则返回undefined不展示悬浮文本
 * 适用:文本超一行（特定字节长度）展示省略号和悬浮文本
 */
export const isExceed = (str: string, n: number) => {
  // eslint-disable-next-line no-control-regex
  const len = str?.replace(/[^\x00-\xff]/gi, '--').length;
  return len > n ? str : undefined;
};
// 获取富文本内容里的纯文本
export const getSimpleText = (html: string) => {
  const re1 = new RegExp('<.+?>', 'g'); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
  const msg = html.replace(re1, ''); // 执行替换成空字符
  return msg;
};
